import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import CustomInterviewModal from './CustomInterviewModal';
import { initAuthErrorHandler } from '@/lib/auth-error-handler';

export default function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    initAuthErrorHandler();
  }, []);

  const hideSidebar = pathname === '/interview/session' || pathname === '/signup' || pathname === '/signup/recruiter' || pathname === '/login';

  if (hideSidebar) {
    return <main>{children}</main>;
  }

  return (
    <>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        onOpenCustomInterview={() => setIsModalOpen(true)}
      />
      <main className={`transition-all duration-300 ${collapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
        {children}
      </main>
      <CustomInterviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
